import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TCustomFieldValue } from '@shared/types/custom-field-value';
import { request } from '@src/core/api/request';
import { useMutation } from '@tanstack/react-query';

type TCreateCustomFieldValuePayload = {
  value: string[];
  entity_id: number;
  field: number;
};

const customFieldValueApi = {...createCrudService<TCustomFieldValue,Record<string, unknown>,TCreateCustomFieldValuePayload>({
  queryKey: [QUERY_KEYS.getCustomFieldValues],
  url: 'custom-field-values',
  factory: {
    bulkDelete: {
      customOptions: {
        disableSuccessToast: true,
      },
    },
 
    bulkCreate: {
      requestOptions: (body?: {value: string[]; entity_id: number; field: number}[]) => ({
        method: 'POST',
        data: body,
      }),
      customOptions: {
        disableSuccessToast: true,
      },
    },
  },
}), 

useUpdateCustomFieldValue: () => useMutation({
  mutationFn: async (updateBody: {value: string[]; id: number}[]) => {
    return await request<TCustomFieldValue>({
      url: 'custom-field-values/bulk-update/',
      method: 'POST',
      body: updateBody,
    });
  },
})
}

export default customFieldValueApi;

